import { ChangeEvent, FC, MouseEvent, PropsWithChildren } from 'react'
import classNames from 'classnames'

import { CheckBoxActiveIcon } from '../../../icons/CheckBoxActiveIcon'
import { CheckBoxEditActiveIcon } from '../../../icons/CheckBoxEditActiveIcon'
import { CheckBoxEditInactiveIcon } from '../../../icons/CheckBoxEditInactiveIcon'
import { CheckBoxInactiveIcon } from '../../../icons/CheckBoxInactiveIcon'

import styles from './CheckBox.module.scss'

export interface CheckBoxProps {
  value: boolean
  disabled?: boolean
  required?: boolean
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void
  onClick?: (value: MouseEvent<HTMLInputElement>) => void
  type?: 'default' | 'edit'
}

export const CheckBox: FC<PropsWithChildren<CheckBoxProps>> = (props) => {
  const {
    value = false,
    disabled = false,
    required = false,
    onChange = () => {},
    onClick,
    type = 'default',
  } = props

  const ActiveIcon = type === 'edit' ? CheckBoxEditActiveIcon : CheckBoxActiveIcon
  const InactiveIcon = type === 'edit' ? CheckBoxEditInactiveIcon : CheckBoxInactiveIcon

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.disabled]: disabled,
      })}
    >
      <input
        type='checkbox'
        checked={value}
        disabled={disabled}
        required={required}
        onChange={onChange}
        onClick={onClick}
        className={classNames(styles.input, {
          [styles.disabled]: disabled,
        })}
      />
      {value ? <ActiveIcon size={24} /> : <InactiveIcon size={24} />}
    </div>
  )
}
